import http from "../../http";

import content from './content'

export default {
  content,
  tdk: {
    save: (params) => {
      return http.post('websitecenter/tdk/save', params)
    },
    get: (params) => {
      return http.get('websitecenter/tdk/get', params)
    },
    del: (params) => {
      return http.get('websitecenter/tdk/delete', params)
    },
    page: (params) => {
      return http.post('websitecenter/tdk/page', params)
    },
  },
  type: {
    save: (params) => {
      return http.post('websitecenter/typetree/save', params)
    },
    list: (params) => {
      return http.get('websitecenter/typetree/get/tree', params)
    },
    del: (params) => {
      return http.get('websitecenter/typetree/delete/id', params)
    }
  },
  website: {
    list: (params) => {
      return http.post('websitecenter/website/page', params)
    },
    get: (params) => {
      return http.get('websitecenter/website/get', params)
    },
    save: (params) => {
      return http.post('websitecenter/website/save', params)
    },
    del: (params) => {
      return http.get('websitecenter/website/delete', params)
    }
  },
  nav: {
    list: (params) => {
      return http.get('websitecenter/menu/get/html/page', params)
    },
    get: (params) => {
      return http.get('websitecenter/menu/get', params)
    },
    save: (params) => {
      return http.post('websitecenter/menu/save', params)
    },
    del: (params) => {
      return http.get('websitecenter/menu/delete/id', params)
    }
  },
  banner: {
    list: (params) => {
      return http.post('websitecenter/picture/page', params)
    },
    get: (params) => {
      return http.get('websitecenter/picture/get', params)
    },
    save: (params) => {
      return http.post('websitecenter/picture/save', params)
    },
    del: (params) => {
      return http.get('websitecenter/picture/delete', params)
    }
  },
  testimony: {
    list: (params) => {
      return http.post('websitecenter/testimony/get/page', params)
    },
    del: (params) => {
      return http.get('websitecenter/testimony/delete/id', params)
    },
    save: (params) => {
      return http.post('websitecenter/testimony/save', params)
    },
 
  },
  product: {
    list: (params) => {
      return http.post('websitecenter/product/page', params)
    },
    get: (params) => {
      return http.get('websitecenter/product/get', params)
    },
    save: (params) => {
      return http.post('websitecenter/product/save', params)
    },
    del: (params) => {
      return http.get('websitecenter/product/delete', params)
    }
  },
  anli: {
    list: (params) => {
      return http.post('websitecenter/customercase/page', params)
    },
    get: (params) => {
      return http.get('websitecenter/customercase/get', params)
    },
    save: (params) => {
      return http.post('websitecenter/customercase/save', params)
    },
    del: (params) => {
      return http.get('websitecenter/customercase/delete', params)
    }
  },
  node: {
    list: (params) => {
      return http.get('websitecenter/node/list', params)
    },
    get: (params) => {
      return http.get('websitecenter/node/get', params)
    },
    save: (params) => {
      return http.post('websitecenter/node/save', params)
    },
    del: (params) => {
      return http.get('websitecenter/node/delete', params)
    }
  },
  hezuo: {
    list: (params) => {
      return http.post('websitecenter/activitycustomer/page', params)
    },
    get: (params) => {
      return http.get('websitecenter/activitycustomer/get', params)
    },
    save: (params) => {
      return http.post('websitecenter/activitycustomer/save', params)
    },
    del: (params) => {
      return http.get('websitecenter/activitycustomer/delete', params)
    }
  },
  active: {
    list: (params) => {
      return http.get('websitecenter/recommand/html/page', params)
    },
    save: (params) => {
      return http.post('websitecenter/recommand/save', params)
    },
    del: (params) => {
      return http.post('websitecenter/recommand/delete?id='+ params, {})
    }
  },
  solution: {
    list: (params) => {
      return http.post('websitecenter/solution/page', params)
    },
    get: (params) => {
      return http.get('websitecenter/solution/get', params)
    },
    save: (params) => {
      return http.post('websitecenter/solution/save', params)
    },
    del: (params) => {
      return http.get('websitecenter/solution/delete', params)
    }
  }
}